import Api from '@/services/api';

import { BeraJobResultDTO, PayloadDownloadPDF, URLDownloadDTO } from './types';
import { UpdateBeraJobSummaryRequest } from '../hooks/types/request';

export class BeraJobResultService {
	public async downloadPDF(payload: PayloadDownloadPDF) {
		const url = `/bera/job-summary/download-pdf/${payload.bera_job_summary_id}`;
		const { data } = await Api.post<URLDownloadDTO>(url, payload);
		return data;
	}

	public async saveComments({ organization_id, company_id, id, comment }: UpdateBeraJobSummaryRequest) {
		const body = {
			organization_id,
			company_id,
			id,
			comment
		};
		const url = `/bera/job-summary/${id}`;
		const { data } = await Api.put<BeraJobResultDTO>(url, body);
		return data;
	}
}
